import { Mask } from '@/types';
import { fetchMasks } from '@/utils/http/fetchMasks';
import { supportsSvgMaskedCanvas } from '@/utils/masks/supportsSvgMaskedCanvas';
import { Thunk } from '@/redux/types';
import { MasksActionTypes, MasksFetchAction } from '../types';

export const fetchMasksAction = (): Thunk<Promise<Mask[]>, MasksFetchAction> => (dispatch) =>
  fetchMasks().then((data) => {
    const masks = supportsSvgMaskedCanvas()
      ? data
      : data.filter((mask) => mask.contentType !== 'image/svg+xml');
    dispatch({
      type: MasksActionTypes.MASKS_FETCH,
      masks,
    });
    return masks;
  });
